<template>
    <div>
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full">
                    <label class="vs-input--label">{{ $t('multipleChoice.topic') }}</label>
                    <vs-input class="w-full" v-model="selectTopic" type="text" data-vv-validate-on="blur"/>
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <label class="vs-input--label">{{ $t('multipleChoice.semester') }}</label>
                    <vs-input class="w-full" v-model="selectSemester" type="text" data-vv-validate-on="blur"/>
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <label class="vs-input--label">{{ $t('multipleChoice.category') }}</label>
                    <v-select class="" v-model="selectCategory" :options="categoryOptionsSearch" :clearable="false"
                              :reduce="(option) => option.value">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <vs-button icon="icon-search" icon-pack="feather" color="primary" class="mt-6 ml-4" @click="getTopic">{{ $t('multipleChoice.search') }}</vs-button>
                <vs-button icon="icon-plus" icon-pack="feather" color="primary" class="mt-6 ml-8"
                           @click="clearData">
                           {{ $t('multipleChoice.button_add_topic') }}
                </vs-button>
            </div>

        </div>
        <div class="vx-card px-4">
            <ag-grid-vue style="height: 55vh" ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef" :rowData="dataTopic" :animateRows="true"
                         :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                          @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy">
            </ag-grid-vue>
            <div class="vx-row mt-8" v-if="totalElements > 0">
                <div class="vx-col md:w-1/2 w-full">
                    <span class="content-page font-bold">{{ $t('dashboard.display') }}: </span>
                    <span class="text-page">
                                {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{
                            totalElements
                        }}
                            </span>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
                </div>
            </div>
        </div>

        <vs-popup :title="$t('multipleChoice.button_add_topic')" :active.sync="popupActiveUse">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <label class="vs-input--label required">{{ $t('multipleChoice.category') }}</label>
                    <v-select class="" v-model="topic.categoryId" :clearable="false" :options="categoryOptions"
                              :reduce="(option) => option.value" v-validate="'required'" name="category">
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('category') }}</span>
                </div>
                <div class="vx-col w-full mt-2">
                    <label class="vs-input--label required">{{ $t('multipleChoice.topic') }}</label>
                    <vs-input class="w-full" v-model="topic.topicName" type="text"  v-validate="'required'" name="topicName"/>
                    <span class="text-danger text-sm">{{ errors.first('topicName') }}</span>
                </div>
                <div class="vx-col w-full mt-2">
                    <label class="vs-input--label required">{{ $t('multipleChoice.semester') }}</label>
                    <vs-input class="w-full" v-model="topic.semester" type="text"  v-validate="'required'" name="semester"/>
                    <span class="text-danger text-sm">{{ errors.first('semester') }}</span>
                </div>
                <div class="vx-col w-full mt-2">
                    <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                        <vs-button class="float-right mr-5" @click="saveTopic">{{ $t('multipleChoice.button_add_topic') }}</vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>
<script>
import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import CellRendererToppicSet from "./cell-renderer/CellRendererTopicSet.vue";
import {ClientSideRowModelModule} from '@ag-grid-community/client-side-row-model';
import moment from "moment";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import {ModuleRegistry} from '@ag-grid-community/core';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        vSelect,
        AgGridVue,
        CellRendererToppicSet
    },
    data() {
        return {
            popupActiveUse: false,
            topic: {
                topicName: null,
                semester: null,
                categoryId: null,
            },
            selectTopic: null,
            selectSemester: null,
            selectCategory: null,
            dataTopic: null,
            dataBack:null,
            categoryOptions: [],
            categoryOptionsSearch:[{value:null , label: this.$t('multipleChoice.all')}],
            pageNumber: 0,
            pageSize: 20,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('multipleChoice.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: this.$t('multipleChoice.topic'),
                    field: 'topicName',
                    width: 300,
                },
                {
                    headerName: this.$t('multipleChoice.category'),
                    field: 'categoryName',
                    width: 300,
                },
                {
                    headerName: this.$t('multipleChoice.semester'),
                    field: 'semester',
                    width: 200
                },
                {
                    headerName: this.$t('menuOrganization.createdDate'),
                    field: 'createdDate',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.updatedDate'),
                    field: 'modifiedDate',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.actions'),
                    field: 'actions',
                    width: 200,
                    cellRenderer: 'CellRendererToppicSet',
                    suppressSizeToFit: true,
                },
            ],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            countElementPage: 0,
            totalElements: 0,
            currentPage: 1,

        }
    },
    async created() {
        await this.getCategory();
        await this.getTopic();
    },
    methods: {
        clearData(){
            this.topic.categoryId = null,
            this.topic.semester = null,
            this.topic.topicName = null,
            this.popupActiveUse = true
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        loadPage: function (currentPage) {
            if (parseInt(currentPage) - 1 != this.pageNumber) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getTopic();
            }
        },
        getCategory() {
            return new Promise((resolve, reject) => {
                let body = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,

                }
                this.$crm.post('/school-quiz-category/find-by-condition', body).then((response) => {
                    this.categoryOptionsSearch  = response.data.content.map(el => {
                        return {
                            label: el.categoryName,
                            value: el.id
                        }
                    })
                    this.categoryOptions = response.data.content.map(el => {
                        return {
                            label: el.categoryName,
                            value: el.id
                        }
                    })
                    this.categoryOptionsSearch.unshift({value:null, label:'Tất cả'})
                    resolve(response)
                }).catch((err) => {
                    reject(response);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })

        },
        async saveTopic(evt) {
            // evt.preventDefault();
            // if (!this.validateForm) return;
            // const result = await this.$validator.validateAll();
            // if (!result) return;
            if(!this.topic.categoryId || !this.topic.semester || !this.topic.topicName){
                return this.$vs.notify({
                    text: this.$t('multipleChoice.notice_field'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                })
            }
            this.$vs.loading();
            this.$crm.post('/school-quiz-topic/create', this.topic).then((response) => {
                this.$vs.loading.close();
                this.popupActiveUse = false;
                this.getTopic();
                return this.$vs.notify({
                    text: this.$t('multipleChoice.update_success'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getTopic() {
            let body = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                topicName: this.selectTopic ? this.selectTopic : null,
                semester: this.selectSemester ? this.selectSemester : null,
                categoryId: this.selectCategory
            }
            this.$vs.loading();
            this.$crm.post('/school-quiz-topic/find-by-condition', body).then((response) => {
                this.dataTopic = response.data.content.map(el => {
                    el.stt = response.data.content.indexOf(el) + 1;
                    el.createdDate = el.createdDate ? moment(el.createdDate).format('DD/MM/YYYY HH:mm') : '';
                    el.modifiedDate = el.modifiedDate ? moment(el.modifiedDate).format('DD/MM/YYYY HH:mm') : '';

                    return el;
                })
                this.dataBack = response.data.content.map(el => {
                    if(this.categoryOptionsSearch){
                        this.categoryOptionsSearch.map( t => {
                            if (t.value === el.categoryId){
                                 el.categoryName = t.label
                            }
                        })
                    }
                })
                this.countElementPage = this.currentPage * 10;
                this.totalElements = this.dataTopic.length
                this.totalPages = response.data.totalPages
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    },
    watch: {
        '$store.state.isDeleteTopicSet'(val) {
            if (val) {
                this.getTopic();
                this.$store.commit('DELETE_TOPICSET', false);
            }
        },
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },
}
</script>
<style>
.required::after {
    content: '* ';
    color: red;
}
</style>
